import React, { useState } from 'react';
import DayRangePicker from './DayRangePicker';

const SearchRange = ({ label, value, onChoose, onClose }) => {
  const [nightsFrom, setNightsFrom] = useState(value[0]);
  const [nightsTo, setNightsTo] = useState(value[1]);
  const setNights = ([from, to]) => {
    setNightsFrom(from);
    setNightsTo(to);
    onChoose(from, to);
  };
  return (
    <div className="popup-body fixed" style={{ height: 'auto' }}>
      <p className='popup-body__header'
        style={{
          textAlign: 'center',
          fontWeight: '700',
          backgroundColor: '#fff !important',
          margin: 0,
          paddingTop: "10px",
          fontSize:"16px"
        }}
      >
        c {nightsFrom} по {nightsTo} ночей
      </p>
      <div className='popup-body__content' style={{ display:"flex", justifyContent:"center", padding:"20px" }}>
        <DayRangePicker onChange={setNights} onClose={onClose} value={value} />
      </div>
    </div>
  );
};

export default SearchRange;
